<template>
<div>
  <el-table :data="pageData.list" :border="true" style="width: 100%" height="90vh">
    <el-table-column label="房产信息" prop="house_name" width="320" fixed="left"></el-table-column>
    <el-table-column label="区域" prop="area_name" width="120"></el-table-column>
    <el-table-column label="业主" prop="customer_name" width="120"></el-table-column>
    <el-table-column label="业主电话" prop="customer_phone" width="180"></el-table-column>
    <el-table-column label="欠费金额" prop="amount_owed" width="120"></el-table-column>
    <el-table-column label="账龄类型" prop="aging_type" width="120"></el-table-column>
    <el-table-column label="催费方式" prop="type_ex" width="120"></el-table-column>
    <el-table-column label="合作单位" prop="thrid_company" width="200"></el-table-column>
    <el-table-column label="发生时间" prop="send_time" width="180"></el-table-column>
    <el-table-column label="催费金额" prop="money" width="120"></el-table-column>
    <el-table-column label="业主诉求" prop="owner_words" width="180"></el-table-column>
    <el-table-column label="解决措施" prop="measures" width="180"></el-table-column>
    <el-table-column label="备注" prop="remarks" width="180"></el-table-column>
    <el-table-column label="第三方统计人" prop="third_operator" width="120"></el-table-column>
    <el-table-column label="项目跟进人" prop="butler_name" width="120"></el-table-column>
    <el-table-column label="项目ID" prop="project_id" width="120"></el-table-column>
    <el-table-column label="房产ID" prop="house_id" width="120"></el-table-column>
    <el-table-column label="sub_proejct_id" prop="sub_proejct_id" width="120"></el-table-column>
    <el-table-column label="area_id" prop="area_id" width="120"></el-table-column>
    <el-table-column label="sub_area_id" prop="sub_area_id" width="120"></el-table-column>
    <el-table-column label="批次号" prop="batch_number" width="120"></el-table-column>
    <el-table-column label="创建时间" prop="create_time" width="180"></el-table-column>
  </el-table>
  <div class="pagination">
    <el-input v-model="pageData.pageSize" type="number" size="mini" style="width: 90px; margin-right: 10px;" placeholder="每页显示条数"></el-input>
    <el-pagination
      layout="prev, pager, next"
      :current-page="pageData.page*1"
      :page-size="pageData.pageSize*1"
      :total="pageData.total*1"
      @current-change="changePage"
    >
    </el-pagination>
  </div>
</div>
</template>

<script>
import ButlerHttp from "../../common/ButlerHttp";

export default {
  name: "ProjectCollectionThridPartyFlowBatchNumberList",
  data() {
    return {
      batchNumber: '',
      pageData: {
        page: 1,
        pageSize: 20,
        total: 0,
        list: []
      }
    };
  },
  mounted() {
    this.batchNumber=this.$route.query.batch_number;
    this.changePage(1)
  },
  methods: {
    getList(){
      const that=this;
      ButlerHttp.post("ThirdPartyLegal/getProjectCollectionThridPartyFlowBatchNumberList", {
        batchNumber: that.batchNumber,
        page: that.pageData.page,
        pageSize: that.pageData.pageSize
      }, ret => {
        if (ret.code) {
          that.pageData = ret.data;
        }
      });
    },
    changePage(page) {
      this.pageData.page = page;
      this.getList();
    },
  }
}
</script>

<style lang="scss" scoped>
.pagination{
  margin-top: 20px;
  display: flex;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/thirdparty/ProjectCollectionThridPartyFlowBatchNumberList.vue